import type { IPascoRepository } from "@src/domain/pascos/repository/pasco_repository";
import type { PreviewUrl } from "@src/domain/pascos/value_objects/preview_url";

/**
 * Get Pasco Preview URL Use Case
 * Retrieves a presigned URL for previewing a PASCO file (JPG image)
 */
export class GetPascoPreviewUrlUseCase {
    constructor(private readonly pascoRepository: IPascoRepository) { }

    async execute(pascoId: string): Promise<PreviewUrl> {
        if (!pascoId) {
            throw new Error("Pasco ID is required");
        }

        return await this.pascoRepository.getPreviewUrl(pascoId);
    }
}
